import { motion } from "framer-motion";
import React, { FC } from "react";
import email from "../../assets/images/email.svg";
import phone from "../../assets/images/phone.svg";
import instagram from "../../assets/images/instagram.svg";
import twitter from "../../assets/images/twitter.svg";
import whatsapp from "../../assets/images/whatsapp.svg";
import { Image } from "cloudinary-react";

export const Contact: FC<{}> = () => {
  return (
    <motion.section id="contact" layout className="contact-section">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="heading">
              <h2>
                Get in Touch With <span>Us.</span>
              </h2>
            </div>
            <div className="contact">
              <img src={email} alt="" />
              <h3>Email</h3>
              <p>info@speednance.com</p>
              <p>support@speednance.com</p>
            </div>
            <div className="contact">
              <img src={phone} alt="" />
              <h3>Phone</h3>
              <p>+233552364091</p>
            </div>
            <div className="handles">
              <div className="handle">
                <a href="https://instagram.com/speednance" target="blank">
                  <img src={instagram} alt="" />
                </a>
              </div>
              <div className="handle">
                <a href="https://twitter.com/speednance" target="blank">
                  <img src={twitter} alt="" />
                </a>
              </div>
              <div className="handle">
                <a href="https://wa.me/message/B6QHPJODSUY2B1" target="blank">
                  <img src={whatsapp} alt="" />
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 d-none d-lg-block">
            <Image publicId="customersupport_sfvkvt" />
          </div>
        </div>
      </div>
    </motion.section>
  );
};
